<!-- <pre>ActionPanelComponent sou {{featureAction.title}} estou visivel {{active ? active+'' : 'false'}}</pre> -->
<fieldset #fs class="service-container" *ngIf="active">
    <suite-rfb-collapse [title]="featureAction.title">
        <ng-content></ng-content>
    </suite-rfb-collapse>
</fieldset>